'use client'

import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { ReactSelectMenu } from '@repo/ui/ReactSelectMenu'
import { useAddressesStore } from '@repo/store/useAddressesStore'
import MUIAlert from '@mui/material/Alert'

export const AddressSelect = ({
  testData = null,
  onChange = (val) => {
    console.log(val)
  },
  sx = {},
  size = 'small',
  searchTerm = '',
  visible = true,
  disabled = false
}) => {
  const { fetchAddresses, fetchSingleAddressById } = useAddressesStore()
  const [fetchedAddresses, setFetchedAddresses] = useState(null)
  const [options, setOptions] = useState(testData || fetchedAddresses || [])
  const [noResults, setNoResults] = useState(false)

  useEffect(() => {
    if (testData) return
    setOptions(fetchedAddresses || [])
  }, [testData, fetchedAddresses])

  useEffect(() => {
    if (testData || !searchTerm) return

    const getAddresses = async () => {
      setNoResults(false)
      const fetchedAddresses = await fetchAddresses(searchTerm)
      setFetchedAddresses(fetchedAddresses)
      if (!fetchedAddresses?.length) setNoResults(true)
    }

    getAddresses()
  }, [testData, fetchAddresses, searchTerm])

  const handleChange = async (args) => {
    const { id } = args || {}

    if (!id) {
      onChange({ house: '', area: '', postalTown: '', county: '', postcode: '' })
      return
    }

    const { house, area, postalTown, county, postcode } = await fetchSingleAddressById(id)
    setFetchedAddresses(null)

    onChange({ house, area, postalTown, county, postcode })
  }

  if (!visible || !searchTerm || !fetchedAddresses?.length)
    return (
      <div
        data-testid="AddressSelect"
        style={{
          width: sx?.width || '100%',
          maxWidth: sx?.maxWidth || '100%',
          marginTop: sx?.marginTop || 0,
          marginBottom: 10
        }}
      >
        {noResults ? (
          <MUIAlert severity="info" sx={{ width: '100%' }}>
            No addresses match the supplied postcode
          </MUIAlert>
        ) : null}
      </div>
    )

  return (
    <div
      data-testid="AddressSelect"
      style={{
        width: sx?.width || '100%',
        maxWidth: sx?.maxWidth || '100%',
        marginBottom: '16px',
        marginTop: sx?.marginTop || 0
      }}
    >
      <ReactSelectMenu
        label="Select address"
        onChange={handleChange}
        labelKey="address"
        valueKey="id"
        items={options}
        showIdInResults={false}
        searchable
        size={size}
        name="addressSelect"
        disabled={disabled}
        menuZindex={9999999}
      />
    </div>
  )
}

AddressSelect.propTypes = {
  testData: PropTypes.array,
  onChange: PropTypes.func,
  sx: PropTypes.object,
  size: PropTypes.string,
  searchTerm: PropTypes.string,
  visible: PropTypes.bool,
  disabled: PropTypes.bool
}
